import { createAction } from '@reduxjs/toolkit'
import { cloneDeep } from 'lodash'
import { ResponseGetPushConsentFormWithTemplates } from '@ads/front-core/api'
import { AppState } from '../../appState'

export const setFormDraft = createAction<
  ResponseGetPushConsentFormWithTemplates['pushConsentFormConfig']
>('draft/setFormDraft')

export const setFormDraftReducer = (
  state: AppState['draft'],
  action: ReturnType<typeof setFormDraft>,
): void => {
  state.form = cloneDeep(action.payload)
}
